import { Box, FormikSelectInputNative } from '@palmetto/palmetto-components';
import { Field } from 'formik';
import { useMemo } from 'react';

import { ConstructionAdderType, ProgramType } from 'types';

import { useGetConstructionAddersQuery } from '../../../../services/pricing';
import { sortByLabel } from '../util';

const removeAdderOption = { label: 'x--Remove Adder--x', value: 'remove' };

export const BulkEditEnergyBackupAddersFormSection = () => {
  const { data: backupBatteryPriceCaps = [] } = useGetConstructionAddersQuery({
    type: ConstructionAdderType.backupBatteryPriceCap,
    programType: ProgramType.energyBackup,
  });
  const { data: arbitrageBatteryPriceCaps = [] } = useGetConstructionAddersQuery({
    type: ConstructionAdderType.arbitrageBatteryPriceCap,
    programType: ProgramType.energyBackup,
  });

  const backupBatteryPriceCapOptions = useMemo(
    () => [
      removeAdderOption,
      ...backupBatteryPriceCaps
        .map((priceCap: any) => ({ label: priceCap.name, value: priceCap.id }))
        .toSorted(sortByLabel),
    ],
    [backupBatteryPriceCaps],
  );

  const arbitrageBatteryPriceCapOptions = useMemo(
    () => [
      removeAdderOption,
      ...arbitrageBatteryPriceCaps
        .map((priceCap: any) => ({ label: priceCap.name, value: priceCap.id }))
        .toSorted(sortByLabel),
    ],
    [arbitrageBatteryPriceCaps],
  );

  return (
    <Box childGap="lg">
      <Field
        name="backupBatteryPriceCap"
        id="backupBatteryPriceCap"
        label="Backup Battery Price Caps"
        component={FormikSelectInputNative}
        options={backupBatteryPriceCapOptions}
      />
      <Field
        name="arbitrageBatteryPriceCap"
        id="arbitrageBatteryPriceCap"
        label="Arbitrage Battery Price Caps"
        component={FormikSelectInputNative}
        options={arbitrageBatteryPriceCapOptions}
      />
    </Box>
  );
};
